import { useEffect } from 'react';
import { formatDocumentTitle } from '@/utils/documentTitle';

/** Sätter document.title till «Vynamn – DQFleet», eller bara DQFleet. */
export function usePageTitle(viewName: string | null | undefined): void {
  useEffect(() => {
    document.title = formatDocumentTitle(viewName);
  }, [viewName]);
}
